export function BusinessIntro() {
  return (
    <section className="border-t border-line bg-white py-16">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
        <h2 className="font-display text-3xl font-bold text-ink">Welcome to Bharat Consultancy</h2>
        <p className="mt-4 text-lg leading-relaxed text-ink/70">
          Bharat Consultancy is one of India&apos;s emerging Tax, Accounting, Business Registration and
          Compliance Consultancy firms. We provide professional services for startups, entrepreneurs, MSMEs,
          companies, professionals and individuals across India.
        </p>
        <p className="mt-4 text-lg leading-relaxed text-ink/70">
          Our mission is to simplify taxation, legal documentation, business registration and statutory
          compliance through technology and professional expertise. Whether you are starting a new business,
          filing taxes, registering GST, obtaining licenses or preparing project reports — we provide complete
          assistance under one roof.
        </p>
      </div>
    </section>
  );
}
